import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface UpdateOfferSingleUseCase {
    invoke: (itemId: number, data: any) => Promise<boolean>;
}
export class UpdateOfferSingle implements UpdateOfferSingleUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
        this.Repo = _Repo;
    }

    async invoke(itemId: number, data: any){
        
        if(!data) {
            throw new Error (
                "Your todo should have at leat 2 characters."
            );
        }
            
        const update  = await this.Repo.updateOfferSingle(itemId, data);
        return update;
    }
}